import JSZip from 'jszip';
import { saveFile, type SaveResult } from './save.js';

export interface ZipEntry {
  filename: string;
  data: ArrayBuffer | Blob;
}

export async function buildZip(entries: ZipEntry[]): Promise<Blob> {
  const zip = new JSZip();
  for (const entry of entries) {
    zip.file(entry.filename, entry.data);
  }
  return zip.generateAsync({ type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 6 } });
}

/**
 * Saves a Blob with the given filename. On the web/PWA this is a plain browser download; inside
 * the iOS/macOS Capacitor shell it writes to the app's sandbox and opens the native share sheet
 * (Save to Photos / Save to Files / Open in… / AirDrop).
 */
export function downloadBlob(blob: Blob, filename: string): Promise<SaveResult | null> {
  return saveFile(blob, filename);
}
